import React, { type ComponentProps, type FC } from 'react';
import { ElementFactory, Question, Serializer } from 'survey-core';
import { ReactQuestionFactory } from 'survey-react-ui';

import PhotoUpload from '../../components/photoUpload';

const PHOTO_UPLOAD_TYPE = 'photo-upload';

export class QuestionPhotoUploadModel extends Question {
  getType() {
    return PHOTO_UPLOAD_TYPE;
  }
  get treatmentCategory() {
    return this.getPropertyValue('treatmentCategory');
  }
  set treatmentCategory(val) {
    this.setPropertyValue('treatmentCategory', val);
  }
}

export const bootPhotoUploadQuestion = () => {
  // Add question type metadata for further serialization into JSON
  Serializer.addClass(
    PHOTO_UPLOAD_TYPE,
    [
      {
        name: 'treatmentCategory',
        default: 'skin',
        choices: ['skin', 'hair'],
        category: 'general',
        visibleIndex: 2, // After the Name and Title
      },
    ],
    () => {
      return new QuestionPhotoUploadModel('');
    },
    'question',
  );

  ElementFactory.Instance.registerElement(PHOTO_UPLOAD_TYPE, (name) => {
    return new QuestionPhotoUploadModel(name);
  });

  ReactQuestionFactory.Instance.registerQuestion(PHOTO_UPLOAD_TYPE, (props) => {
    return React.createElement<ComponentProps<any>>(PhotoUpload as FC, props);
  });
};
